export default {
  BASE_URL: '/tm',
  api: [
    {
      name: 'getIfPower',
      desc: '获取权限',
      method: 'GET',
      path: '/payment/arrival/getIfPower'
    },
    {
      name: 'busList',
      desc: '到账管理列表',
      method: 'GET',
      path: '/payment/selectList'
    },
    {
      name: 'selectPayDetail',
      desc: '到账管理详情',
      method: 'GET',
      path: '/payment/selectPayDetail'
    },
    {
      name: 'save',
      desc: '到账管理保存金额或完成收款',
      method: 'POST',
      path: '/payment/save'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/self/sales/payment.js